$("#JsSearchForm input").keyup(function() {
  $.get($("#JsSearchResult").attr("action"), $("#JsSearchForm").serialize(), null, "script");
  return false;
});
